import { Component } from '@angular/core';

/**
 * Provides main layout, menu and router outlet for feature modules
 */
@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent {
  constructor() {}
}
